class CollectionWithTextSidebar extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.abortController = new AbortController();
  }

  connectedCallback() {
    const carouselId = this.getAttribute('carousel-id');
    const sectionId = this.getAttribute('section-id');
    
    if (!carouselId || !sectionId) return;

    const carousel = document.getElementById(carouselId);
    if (!carousel) return;

    const blockContents = this.querySelectorAll(`.collection-with-text__block-content`);
    if (blockContents.length === 0) return;

    // Initialize with first block content
    if (blockContents[0]) {
      blockContents[0].classList.add('is-visible');
      this.currentIndex = 0;
    }

    carousel.addEventListener('carousel:settle', (event) => {
      this.updateSideContent(event.detail.index, blockContents);
    }, { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  updateSideContent(newIndex, blockContents) {
    if (newIndex === this.currentIndex) return;
    
    const oldContent = blockContents[this.currentIndex];
    const newContent = blockContents[newIndex];
    
    if (!oldContent || !newContent) return;
    
    // Animate out the old content
    const fadeOut = oldContent.animate(
      { 
        opacity: [1, 0], 
        transform: ['translateY(0)', 'translateY(-15px)'] 
      },
      { 
        duration: 300, 
        easing: 'ease-in',
        fill: 'forwards'
      }
    );
    
    fadeOut.addEventListener('finish', () => {
      oldContent.classList.remove('is-visible');
      
      // Show new content
      newContent.style.display = 'flex';
      newContent.classList.add('is-visible');
      
      // Reset transform for animation
      newContent.style.opacity = '0';
      newContent.style.transform = 'translateY(15px)';
      
      // Animate in the new content
      requestAnimationFrame(() => {
        const fadeIn = newContent.animate(
          { 
            opacity: [0, 1], 
            transform: ['translateY(15px)', 'translateY(0)'] 
          },
          { 
            duration: 400, 
            easing: 'ease-out',
            fill: 'forwards'
          }
        );
        
        fadeIn.addEventListener('finish', () => {
          newContent.style.opacity = '';
          newContent.style.transform = '';
        });
      });
    });
    
    this.currentIndex = newIndex;
  }
}

if (!window.customElements.get("collection-with-text-sidebar")) {
  window.customElements.define("collection-with-text-sidebar", CollectionWithTextSidebar);
}
